export class CustomerContactCard {
    id!: number
    created_at!: Date
    updated_at!: Date
    number!: string
    expire_month!: number
    expire_year!: number
    api_type!: string
    api_id!: string
}
